import { render, staticRenderFns } from "./comp_OrderTotalGoalProgress.vue?vue&type=template&id=70fe3cec&"
import script from "./comp_OrderTotalGoalProgress.vue?vue&type=script&lang=js&"
export * from "./comp_OrderTotalGoalProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VIcon,VProgressLinear,VSpacer})
